
<template>

 <v-card v-role="roles">
   <v-overlay :value="$store.state.isloading">
      <v-progress-circular
        indeterminate
        size="64"
      >
      <span v-if="$store.state.isloading"  style="font-size:15px;">{{titulo }} abrirá em uma nova janela...Por favor aguarde</span>
</v-progress-circular>
    </v-overlay>
     <v-progress-linear  style="margin : 0 auto ; height:10px" indeterminate v-if="isLoading"></v-progress-linear>
     <v-btn
                  @click="(backTo!== null)?$router.push(backTo):backTodisciplinList"
                  class="mx-2"
                  fab
                  dark
                  color="primary"
                >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>
   <v-card-title>
      Lista dos Estudantes na turma {{this.$store.state.objturma.pkTurma}}

        <v-chip
              v-if="true"
              class="ma-2"
              close
              color="pink"
              label
              outlined
              >
              {{(!this.$store.state.fromMinhaTurmas)?this.$store.state.objturma.turmadescricao:this.$store.state.objturma.descricao}}
          </v-chip>
          <v-spacer></v-spacer>
          <span>Selecionado : <strong style="font-size:22px;">{{$store.state.novadescricaoSelecionado}}</strong></span>
       <v-row style="position:fixed;background-color:yellow;" v-if="progresso">
                       <v-col  >
                        <v-progress-circular
                        :size="50"
                        color="green"
                        indeterminate
                      ></v-progress-circular>
                      <span style="font-size:15px;">{{tipoDocumento}} abrirá em uma nova janela...Por favor aguarde</span>
                      </v-col>

                </v-row>
      <v-spacer></v-spacer>
    <img @click="this.dialog = true" style="margin-left:30px"  width="30px"  src="../../../../../assets/download.png">
     <img  @click="carregarEstudantesTurmaPDF()"  style="margin-left:30px"  width="30px"  src="../../../../../assets/pdf_exibir.png">
    </v-card-title>
    <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>
  <v-data-table
    :headers="headers"
    :items="listEstudantfromPauta"
    :items-per-page="50"
    class="elevation-1">

  <template v-slot:item.action="{ item }">
      <v-menu
      bottom
      origin="center center"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          fab dark color="teal"
          style="color:white"
          v-on="on"
        >
          <v-icon>menu</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="Boletim(item)"> <v-icon>insert_drive_file</v-icon> <span> - Boletim</span></v-list-item>
        <v-list-item v-if="isIlha && $store.state.objturma.idAno_Academico === 4 && item.resultado==='Transita'" @click="carregarCartaRecomendacao(item)" ><v-icon>print</v-icon> - Carta de Recomendação</v-list-item>
        <v-list-item v-if="isIlha" @click="carregarcartaoestudante(item)"> <v-icon  class="mr-2">print</v-icon> <span> - Cartão de Estudante</span></v-list-item>
        <v-list-item v-if="$store.state.objturma.idAno_Academico === 4 && item.resultado==='Transita'" @click="carregarcertificado(item)" ><v-icon>print</v-icon> - Certificado</v-list-item>
        <v-list-item v-if="isIlha" @click="declaracao_notas(item);"><v-icon>print</v-icon> <span> - Declaração com notas</span></v-list-item>
        <v-list-item @click="declaracao(item)"><v-icon>print</v-icon> <span> - Declaração sem notas</span></v-list-item>
        <v-list-item v-if="isIlha" @click="carregarGuiaTransferencia(item)"> <v-icon  class="mr-2">print</v-icon> <span> - Guia de transferência</span></v-list-item>
        <v-list-item v-if="false" @click="comporFichaMatricula(item)"><v-icon>print</v-icon> <span> - Ficha de matricula</span></v-list-item>
        <v-list-item v-if="isIlha" @click="carregarFichaDadosBiograficoAcademico(item)" ><v-icon>print</v-icon> - Ficha de dados biográfico académico</v-list-item>
        <v-list-item v-if="isIlha" @click="carregarHistoricoAcademico(item)"> <v-icon>insert_drive_file</v-icon> <span> - Histórico académico</span></v-list-item>
        <v-list-item @click="showEliminar(item)" v-if="role === 'ROLE_ADM'"> <v-icon color="red">delete</v-icon> <span style="color:red;" > - Eliminar</span></v-list-item>
        <v-list-item @click="showAddDisciplina(item)" v-if="role === 'ROLE_ADM'"> <v-icon >add</v-icon> <span > - Add disciplina Pauta</span></v-list-item>
      </v-list>
    </v-menu>

      <!--<v-img  style="color:green" src="../assets/boletim.jpg" width="80px"  class="mr-2" @click="editItem(item)"></v-img>-->
    </template>
  </v-data-table>

   <!-- =============== Dialgo add Pauta ================================================ -->

      <template>
            <v-row justify="center">
              <v-dialog
                v-model="dialogoPauta"
                persistent
                max-width="600px"
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Adicionar disciplina na Pauta</span><br>
                  </v-card-title>
                  <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            label="Estudante"
                            required
                            v-model="editedItemPauta.nome"
                            :disabled="true"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            label="Turma"
                             v-model="editedItemPauta.turma"
                            :disabled="true"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            label="Classe"
                            required
                             v-model="editedItemPauta.classe"
                            :disabled="true"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            label="Anolectivo"
                             v-model="editedItemPauta.anoLectivo"
                            required
                            :disabled="true"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="8"
                        >
                          <v-combobox
                            :items="disciplinas_"
                            item-text="descricao"
                            v-model="editedItemPauta.disciplina"
                            label="Selecione a disciplina"
                            return-object
                            required
                          ></v-combobox>
                        </v-col>

                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="dialogoPauta = false"
                    >
                      Fechar
                    </v-btn>
                    <v-btn
                      color="green darken-1"
                      text
                      @click="AdicionarDisciplinaPauta()"
                    >
                      Salvar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>

   <!-- ==================== FIM DIALOGO ================================================ -->

   <!-- ============================================================================ -->
           <v-row justify="center">
            <v-dialog v-model="dialog_delete" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Eliminar estudante</v-card-title>
                <v-card-text>Tem a certeza que pretente continuar com esta operação ? </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog_delete = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="Delete()">Continuar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
      <!--=================================================================================-->

<!--======================================EXPORTAR PARA O EXECEL==============================================-->
  <template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
         Exportar para Excel - Deseja Continuar
        </v-card-title>

        <v-card-text>
            Clique para Continuar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="background-color:red;color:white" @click="dialog=false">Cancelar</v-btn>
           <export-excel
                :data   = "listEstudantfromPauta"
              :fields="campos"
              >
          <v-btn @click="dialog=false">Continuar</v-btn>
        </export-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </template>
<!--==========================================================================================-->
    <listaestudante v-if="$store.state.showDialogGuia.listaestudante"/>
    <guiatransferencia v-if="$store.state.showDialogGuia.guia"/>
    <fichadadosbiograficoacademico v-if="$store.state.showDialogGuia.ficha"/>
    <historicoacademico v-if="$store.state.showDialogGuia.historico"/>
    <cartaoescolar v-if="$store.state.showDialogGuia.cartao"/>
    <declaracaonotas v-if="$store.state.showDialogGuia.declaracao_nota"/>
    <declaracao v-if="$store.state.showDialogGuia.declaracao"/>
    <cartarecomendacao v-if="$store.state.showDialogGuia.carta"/>
 </v-card>
</template>

<script>
import axios from '../../../../../plugins/axios'
import 'cropperjs/dist/cropper.css'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  components: {
    listaestudante: () => import('../../../componentes/listaestudante.vue'),
    declaracao: () => import('../../../componentes/declaracao.vue'),
    guiatransferencia: () => import('../../../componentes/guiatransferencia.vue'),
    fichadadosbiograficoacademico: () => import('../../../componentes/fichadadosbiografico.vue'),
    historicoacademico: () => import('../../../componentes/historicoacademico.vue'),
    cartaoescolar: () => import('../../../componentes/cartao.vue'),
    declaracaonotas: () => import('../../../componentes/declaracao_nota.vue'),
    cartarecomendacao: () => import('../../../componentes/carta.vue')
  },
  data: () => ({
    iscarta: false,
    progresso2: false,
    titulo: '',
    enderecamentoCarta: [ ],
    destinatario: { enderecamentoCarta: null, descricao: '' },
    historico_relatorio: [],
    imagecard: ls.get('cardEstudante'),
    insignia: ls.get('insignia'),
    logotipo: ls.get('logotipo'),
    readImage2: ls.get('urlReport') + `readfile/`,
    readImage: `http://192.168.18.15/readfile/`,
    isnotas: false,
    isloadingNewPhoto: false,
    data: null,
    imgSrc: '',
    cropImg: '',
    generateQR: null,
    roles: 'func',
    formValid: true,
    items: [
      { title: 'Click Me' },
      { title: 'Click Me' },
      { title: 'Click Me' },
      { title: 'Click Me 2' }
    ],
    dialog_dec: false,
    certificados: [
      {
        'matricula': '',
        'objAlunoCertificado': {}
      }
    ],
    certificadoDoAluno: {
      'dados_pessoais': {},
      'notas': { 'componente1': [], 'componente2': [], 'componente3': [], 'componente4': [] }
    },
    dialogDeclaracao: false,
    date: null,
    mes_ano: '',
    data_actual: '',
    dataHora: '',
    hora: '',
    formatter: 0,
    html: ``,
    componente: [],
    componente2: [],
    componente3: [],
    componente4: [],
    tipoDocumento: 'O certificado',
    on: false,
    json_meta: [
      [
        {
          'key': 'charset',
          'value': 'utf-8'
        }
      ]
    ],

    campos: {
      'Nome Completo': 'nome',
      'Número de Matricula': 'idMAtricula',
      'Resultado': 'resultado'
    },
    headers: [
      {
        text: 'Nome',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      { text: 'Matricula', value: 'idMAtricula' },
      { text: 'Resultado', value: 'resultado' },
      { text: 'Registrado por', value: 'autor' },
      { text: 'Registrado em', value: 'data_registro' },
      { text: 'Operações permitidas', value: 'action', sortable: false }

    ],

    text: '',
    certificadosPago: [],
    dialogCert: false,
    iscertificado: 0,
    backTo: null,
    Efeitodescricao: '',
    efeitoSelected: null,
    editedpk: false,
    progresso: false,
    progresso_2: false,
    dialog_delete: false,
    canPrint: [],
    disciplinas_: [],
    classe: '',
    dialog: false,
    dialogoDisabilita: false,
    dialogo: false,
    idanoacademico: 0,
    offset: true,
    tumaSelect: '',
    iddisciplina: 0,
    btn_description: '',
    turma_selecionada: '',
    publicar_status: false,
    isLoading: true,
    idturma: 0,
    dialogo_turma: false,
    closeOnClick: true,
    dialogoPauta: false,
    item: 1,
    efeitos: [],
    listaPautasBloquadas: [],
    classe_selecionada: '',
    btn_activacao: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    editedIndex: -1,
    editedItem: {
      ResidenteEm: 0,
      anoLectivo: '',
      auto_data: '',
      autor: null,
      bi: '',
      certificado: null,
      data_: '',
      data_2: '',
      dataemissaobi: '',
      datanascimento: '',
      descricao: '',
      descricao_certificado: '',
      email: '',
      emitirCertificado: null,
      emitirCertificadoAutor: null,
      emitirCertificadoData: null,
      emitirCertificadoValidacaoStep: null,
      fkPessoa: 0,
      fkTurma: 0,
      flag_dados_preparados: null,
      flag_transferencia: 0,
      foto: null,
      idAnoLectivo: null,
      idAno_Academico: 0,
      idCurso: 0,
      idInscricao_na_turma: '',
      idMAtricula: '',
      idMatricula: '',
      idMunicipio: 0,
      idPEssoa: '',
      idPerfil: 0,
      idTurma: '',
      idano_academico: '',
      idinstituicao: 0,
      instituicao: 0,
      instituicaodescricao: '',
      morada: '',
      nome: '',
      nomedamae: '',
      nomedopai: '',
      periodo: '',
      pkInscricao_na_turma: 0,
      pkPessoa: 0,
      pkTurma: 0,
      resultado: '',
      sexo: '',
      status_2: '',
      telefone: '',
      trasferidoIN: '',
      turma: '',
      unique_field: null
    },
    editedItemPauta: {
      nome: '',
      turma: '',
      anoLectivo: '',
      classe: '',
      disciplina: ''
    },
    itemPauta: null,
    disciplinas: [],
    editedItem_mudar_classe: {
      nome: '',
      idAno_Academico: 0,
      idMAtricula: '',
      idTurma: '',
      idCurso: 0

    },
    classes: [
      '10ª Classe',
      '11ª Classe',
      '12ª Classe',
      '13ª Classe'
    ],
    configuracoesReport: []
  }),
  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    role () {
      return ls.get('role')
    },
    isIlha () {
      return (ls.get('i_id') === 24 ? 1 : 0)
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    this.$store.state.isloading = false
    this.$store.state.showDialogGuia = { cartao: false, carta: false, declaracao: false, declaracao_nota: false, ficha: false, guia: false, historico: false, listaestudante: false }
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    this.$store.state.isloading = false
    this.backTo = ls.get('backTo')
    this.pautaByTurma()
  },

  methods: {
    classe_ (idanoacademico) {
      if (idanoacademico === 1) {
        this.classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this.classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this.classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this.classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
    },

    IDano_academico (classe) {
      if (classe === '10ª Classe') {
        return 1
      }
      if (classe === '11ª Classe') {
        return 2
      }
      if (classe === '12ª Classe') {
        return 3
      }
      if (classe === '13ª Classe') {
        return 4
      }
    },

    backToTurmas () {
      this.$router.push('painelClassTurma')
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.pkpauta
      this.editedItem.trimestre = this.$store.state.idperfilpauta
      this.editedItem.pkpauta = item.pkpauta

      setTimeout(() => {}, 1000)
    },
    MostrarDialogo () {
      this.dialog = true
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },

    bt_save (editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      editedItem.p1_MD = Math.round(
        (Number(editedItem.p1_notaMac) +
          Number(editedItem.p1_nota) +
          Number(editedItem.p1_nota2)) /
          3
      )
      editedItem.p2_MD = Math.round(
        (Number(editedItem.p2_notaMac) +
          Number(editedItem.p2_nota) +
          Number(editedItem.p2_nota2)) /
          3
      )
      editedItem.p3_MD = Math.round(
        (Number(editedItem.p3_notaMac) +
          Number(editedItem.p3_nota)) /
          2
      )
      if (this.formValid) {
        this.save(editedItem)
        Object.assign(this.listEstudantfromPauta[this.editedIndex], editedItem)
        this.editedpk = 0
      }
      setTimeout(() => {}, 1000)
    },
    backTodisciplinList () {
      if (!this.$store.state.fromMinhaTurmas) { this.$router.push('painelClassTurma') } else { this.$router.push('minhas-turmas') }
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    async turmaFindWithEstudanteCount (idclasse) {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },
    async save (editedItem) {
      var params = {
        p1_notaMac: editedItem.p1_notaMac,
        p1_nota: editedItem.p1_nota,
        p1_nota2: editedItem.p1_nota2,
        p1_MD: editedItem.p1_MD,
        p2_notaMac: editedItem.p2_notaMac,
        p2_nota: editedItem.p2_nota,
        p2_nota2: editedItem.p2_nota2,
        p2_MD: editedItem.p2_MD,
        p3_notaMac: editedItem.p3_notaMac,
        p3_nota: editedItem.p3_nota,
        p3_MD: editedItem.p3_MD,
        pg: editedItem.pg,
        ca: editedItem.ca,
        mfd: editedItem.mfd,
        autor: editedItem.autor,
        pkpauta: editedItem.pkpauta,
        trimestre: editedItem.trimestre
      }

      try {
        let msg = await axios.post('/lancarNota', params).then(res => res.data)
        // this.text = msg[1].insertId
        this.text = msg

        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {

        }
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}

        if (this.editedIndex > -1) {
          //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
        } else {
          this.estudantes.push(this.editedItem)
        }
        //  this.close();
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text + ' - ' + error,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
      }
    },

    showAddDisciplina (item) {
      this.itemPauta = item
      this.editedItemPauta = Object.assign(this.editedItemPauta, item)
      this.ObterDisciplinas(item.idCurso, item.idAno_Academico).then((res) => {
        this.disciplinas_ = res
        this.dialogoPauta = true
      })
    },

    async pautaByTurma (obj) {
      // carrega turma apartir de bauta  Turma
      this.isLoading = true

      try {
        this.listEstudantfromPauta = await axios

          .get('/ListaEstudantes/' + this.$store.state.objturma.pkTurma)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        // this.isLoading = false
        this.isLoading = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    showEliminar (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_delete = true
    },

    async Delete () {
      let params =
        {
          pkLixeira: 0,
          tabela_from: 'Pessoa',
          descricao: 'Eliminou o registro do estudante :' + this.editedItem.nome + ' Bilhete: ' + this.editedItem.bi + ' da lista de estudantes fora da turma',
          id_from: this.editedItem.pkPessoa,
          matricula: this.editedItem.idMatricula,
          status: 1
        }

      try {
        let msg = await axios
          .post('/LixeiraInsertOrUpdate', params)
          .then(res => res.data)
        if (!msg.length) {
          this.text = 'Estudante eliminado com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 5000 })
          this.dialog_delete = false
          this.listEstudantfromPauta.splice(this.editedIndex, 1)
        }
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async ObterDisciplinas (idCurso, idacademico) {
      return await axios
        .post('/disciplina_curso_classe', { idCurso: idCurso, idanoacademico: idacademico })
        .then(res => res.data)
    },

    AdicionarDisciplinaPauta () {
      this.disciplinaExistenteNaPauta(this.itemPauta).then((res) => {
        if (res.length) {
          this.$store.dispatch('textMessage', { 'msg': 'Disciplina já existente na Pauta', 'classMessage': 'msgError', 'timeout': 3000 })
        } else {
          let obj =
               {
                 iddisciplina: this.editedItemPauta.disciplina.iddisciplina,
                 descricao: this.editedItemPauta.disciplina.descricao,
                 anoacademico: this.itemPauta.idAno_Academico,
                 bienal: this.editedItemPauta.disciplina.bienal,
                 matricula: this.itemPauta.idMatricula,
                 fkInscricao: this.itemPauta.pkInscricao_na_turma,
                 pkturma: this.itemPauta.pkTurma,
                 bi: this.itemPauta.bi,
                 idturma: this.itemPauta.idTurma,
                 anolectivo: this.itemPauta.anoLectivo
               }
          this.AddDisciplina(obj).then((res) => {
            if (res.affectedRows >= 1) {
              this.$store.dispatch('textMessage', { 'msg': 'Disciplina adicionada com sucesso', 'classMessage': 'msgSucess', 'timeout': 3000 })
              this.dialogoPauta = false
            } else { this.$store.dispatch('textMessage', { 'msg': 'Ocorreu um erro ao tentar efectuar a operação', 'classMessage': 'msgError', 'timeout': 3000 }) }
          })
        }
      })
    },

    async disciplinaExistenteNaPauta (item) {
    //  turmaFindWithEstudanteCount
      let obj = { matricula: item.idMatricula, anolectivo: item.anoLectivo, iddisciplina: this.editedItemPauta.disciplina.iddisciplina, pkturma: item.pkTurma, anoacademico: item.idAno_Academico }
      return await axios
        .post('/verificaDisciplinaExistentePauta', obj)
        .then(res => res.data)
    },

    async AddDisciplina (obj) {
    //  turmaFindWithEstudanteCount
      return await axios
        .post('/add_disciplina_pauta', obj)
        .then(res => res.data)
    },

    declaracao (item) {
      this.titulo = 'A declaração sem notas'
      ls.set('relatorio-estudante', { id: 8, descricao: 'Declaração sem Notas' })
      this.$store.state.objAluno = item
      this.$store.state.showDialogGuia.declaracao = true
    },
    declaracao_notas (item) {
      this.titulo = 'A declaração com notas'
      ls.set('relatorio-estudante', { id: 7, descricao: 'Declaração com Notas' })
      this.$store.state.objAluno = item
      this.$store.state.showDialogGuia.declaracao_nota = true
    },
    async  carregarHistoricoAcademico (item) {
      try {
        let estudantedados = await axios
          .get('/PesquisaGlobal/' + item.idMatricula)
          .then(res => res.data)
        if (estudantedados.length) {
          this.titulo = 'O Histórico Académico'
          ls.set('relatorio-estudante', { id: 1, descricao: 'Histórico Académico' })
          this.$store.state.listEstudantfromPauta = estudantedados
          this.$store.state.isloading = true
          this.$store.state.showDialogGuia.historico = true
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar os dados'
        })
      }
    },

    async carregarFichaDadosBiograficoAcademico (item) {
      try {
        let estudantedados = await axios
          .get('/PesquisaGlobal/' + item.idMatricula)
          .then(res => res.data)
        if (estudantedados.length) {
          this.titulo = 'A Ficha de Dados Biográfico Académico'
          ls.set('relatorio-estudante', { id: 3, descricao: 'Ficha de Dados Biográfico Académico' })
          this.$store.state.listEstudantfromPauta = estudantedados
          this.$store.state.objAluno = item
          this.$store.state.isloading = true
          this.$store.state.showDialogGuia.ficha = true
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar os dados'
        })
      }
    },
    carregarCartaRecomendacao (item) {
      this.titulo = 'A Carta de recomendação'
      ls.set('relatorio-estudante', { id: 4, descricao: 'Carta de recomendação' })
      this.$store.state.objAluno = item
      this.$store.state.isloading = true
      this.$store.state.showDialogGuia.carta = true
    },
    async carregarGuiaTransferencia (item) {
      try {
        let estudantedados = await axios
          .get('/PesquisaGlobal/' + item.idMatricula)
          .then(res => res.data)
        if (estudantedados.length) {
          let i = 0
          estudantedados.forEach(element => {
            if (i < element.idAno_Academico) {
              i = element.idAno_Academico
              this.$store.state.objAluno = element
            }
          })
          this.titulo = 'A Guia de Transferência'
          ls.set('relatorio-estudante', { id: 5, descricao: 'Guia de Transferência' })
          this.$store.state.isloading = true
          this.$store.state.showDialogGuia.guia = true
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar os dados'
        })
      }
    },
    carregarcartaoestudante (item) {
      item.anoLectivo = this.$store.state.novadescricaoSelecionado
      this.titulo = 'O Cartão de Estudante'
      ls.set('relatorio-estudante', { id: 6, descricao: 'Cartão de Estudante' })
      this.$store.state.objAluno = item
      this.$store.state.isloading = true
      this.$store.state.showDialogGuia.cartao = true
    },
    Boletim (item) {
      this.tipoDocumento = 'O Boletim'
      this.$store.state.objAluno = item
      this.$store.state.backTo = '/ListaAlunos24'
      this.$router.push('/Novo-Boletim24')
    },
    async carregarcertificado (item) {
      window.open('https://certificado.softlineangola.com/#/login/?q=' + item.idMAtricula + '/' + ls.get('token'), '_blank').focus()
    },

    carregarEstudantesTurmaPDF () {
      this.titulo = 'A lista de alunos na turma'
      this.$store.state.isloading = true
      this.$store.state.listEstudantfromPauta = this.listEstudantfromPauta
      this.$store.state.showDialogGuia.listaestudante = true
    },

    comporFichaMatricula (dados) {
      this.data_hora()
      this.tipoDocumento = 'A ficha de confirmação'
      let options = { 'width': '190mm',
        'height': '80mm',
        'border': {
          // default is 0, units: mm, cm, in, px
          'right': '9mm',
          'left': '9mm'
        },
        'header': {
          'height': '10mm' },
        'footer': {
          'height': '1mm'

        } }

      this.html = ` 
    <style>
  .footer {
    position:absolute;
    bottom:0;
    width:100%;
  }
  #content {
    display: table;
  }

  #pageFooter {
    display: table-footer-group;
     position:absolute;
    bottom:0;
    width:100%;
  }

  #pageFooter:after {
    counter-increment: page;
    content: counter(page);
  }
  .linha {
    border-bottom: 1px solid black;
    border-color: #808080;
    padding-top:2px
  }
   th, td {
      font-size:8px;
      
  }

  </style>
    
    <div style="text-align:left;margin:10px;margin-top:0px" class="invoice-box">
    <table style="border:0px solid black;margin-left:0px;margin-right:auto;">
    <tr>
        <td>
             
        </td>
         <td> 
        <strong style="font-size:20">` + dados.instituicaodescricao + `</strong>
        </td>
         
    </tr>
    
       </table>

  <br>
      <table style="border:0px solid black;border-collapse: collapse;width:100%">
      <tr>
      <td colspan="7" style="text-align:center;">
       <div style="font-size: 12px;"><strong>FICHA DE MATRICULA </strong></div>
      </td>
      </tr>
       <tr>
      <td colspan="6" style="font-size:10px">  DATA: ` + this.data_actual + ` </td>
      <td style="font-size:10px;text-align:right"> HORA: ` + this.hora + `</td>
      </tr>
      <tr>
      <td colspan="7"><div class="linha"></div> </td>
      </tr>
        <tr style="font-size: 10px;">
      <td colspan="4" style="font-size:10px">
     <strong> Nome:</strong>  ` + dados.nome + ` 
     </td>
      <td colspan="2" style="font-size:10px">
     <strong> Matricula:</strong>  ` + dados.idMatricula + ` 
     </td>
     <td style="text-align:right;font-size:10px">
     <strong> Classe:</strong> 10ª 
     </td>
     </tr>
     <tr>
     <td colspan="3" style="font-size:10px">
     <strong> Curso:</strong> ` + dados.curso + `
     </td>
     <td colspan="3" style="font-size:10px">
     <strong> Turma:</strong> ` + dados.turma + `
     </td>
      <td colspan="2" style="text-align:right;font-size:10px">
     <strong> Ano Lectivo:</strong>  ` + this.$store.state.novadescricaoSelecionado + `  
      </td>
      </tr>
       <tr>
      <td colspan="7"><div class="linha"></div> </td>
      </tr>    
      </table>
      <div style="padding-left:90px;padding-top:10px">_____________________________</div>
<div style="padding-left:190px;font-size:10px">Assinatura</div>

 <div style="text-align:left;margin:10px;margin-top:0px" class="invoice-box">
    <table style="border:0px solid black;margin-left:0px;margin-right:auto;">
    <tr>
        <td>
            
        </td>
         <td> 
        <strong style="font-size:20">` + dados.instituicaodescricao + `</strong>
        </td>
         
    </tr>
    
       </table>

  <br>
      <table style="border:0px solid black;border-collapse: collapse;width:100%">
      <tr>
      <td colspan="7" style="text-align:center;">
       <div style="font-size: 12px;"><strong>FICHA DE MATRICULA </strong></div>
      </td>
      </tr>
       <tr>
      <td colspan="6" style="font-size:10px">  DATA: ` + this.data_actual + ` </td>
      <td style="font-size:10px;text-align:right"> HORA: ` + this.hora + `</td>
      </tr>
      <tr>
      <td colspan="7"><div class="linha"></div> </td>
      </tr>
        <tr style="font-size: 10px;">
      <td colspan="4" style="font-size:12px">
     <strong> Nome:</strong>  ` + dados.nome + ` 
     </td>
      <td colspan="2" style="font-size:10px">
     <strong> Matricula:</strong>  ` + dados.idMatricula + ` 
     </td>
     <td style="text-align:right;font-size:10px">
     <strong> Classe:</strong> 10ª 
     </td>
     </tr>
     <tr>
     <td colspan="3" style="font-size:10px">
     <strong> Curso:</strong> ` + dados.curso + `
     </td>
     <td colspan="3" style="font-size:10px">
     <strong> Turma:</strong> ` + dados.turma + `
     </td>
      <td colspan="2" style="text-align:right;font-size:10px">
     <strong> Ano Lectivo:</strong>  ` + this.$store.state.novadescricaoSelecionado + `  
      </td>
      </tr>
       <tr>
      <td colspan="7"><div class="linha"></div> </td>
      </tr>    
      </table>
      <div style="padding-left:90px;padding-top:10px">_____________________________</div>
<div style="padding-left:190px;font-size:10px">Assinatura</div>
              `
      this.gerarPdf(options)
    }
  }
}
</script>
